import React from "react";
import "../../assets/css/Global.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const footerStyle = {
    position: 'fixed',
    left: 0,
    bottom: 0,
    width: '100%',
    //color: '#64748b',
    color: 'var(--muted, #64748b)',
    fontSize: '12px',
    marginTop: '100px',
    padding: '16px 0',
    textAlign: 'center',
    backgroundColor: 'white',
    zIndex: 100,
    boxSizing: 'border-box'
  };

  return (
    <footer style={footerStyle}>
      © {currentYear} Fempulse
    </footer>
  );
};

export default Footer;
